module.exports = __webpack_public_path__ + "img/guf.38dfa23a.svg";